import React, { ReactNode } from 'react';
import { styled } from '@mui/material';

const classesPrefix = 'pageContent';

const classes = {
    contentContainer: `${classesPrefix}-contentContainer`,
};

const StyledDiv = styled('div')(({ theme }) => {
    return {
        [`&.${classes.contentContainer}`]: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'stretch',
            flexGrow: 1,
            '@media (max-height: 660px)': {
                minHeight: '90vh',
            },
            [theme.breakpoints.down('sm')]: {
                minHeight: '90vh',
            },
        },
    };
});

const PageContent = ({
    children,
}: {
    children?: ReactNode;
}): React.JSX.Element => {
    return (
        <StyledDiv id='content-container' className={classes.contentContainer}>
            {children}
        </StyledDiv>
    );
};

export default PageContent;
